export default __webpack_public_path__ + "static/media/khaled_zagoub___Resume.9e0d3a0b.pdf";